module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"typeToSearch":"Type to search...","tapToSearch":"Tap to search..."},"es":{"typeToSearch":"Escribe para buscar...","tapToSearch":"Pulsa para buscar..."}}')
  delete Component.options._Ctor
}
